import $http from '@vue-util/http';

import { errorHandler } from '@/utils/ErrorHandler';
import { KILLSWITCHES_ENDPOINT, FURNITURE_LOOKUP_ENDPOINT, FURNITURE_STATUS_ENDPOINT, FURNITURE_STATUS_ENDPOINT_MEW_MODE } from '#shared/endpoints';
import { ORDER_LOOKUP } from 'config';

const { furnitureFallbackError, furnitureFallbackErrorMew } = ORDER_LOOKUP;

function transformMewModeResponseToDesktop(order) {
  const deliveryStatusVB = {
    orderDetails: order,
    deliveryStatus: order.deliveryStatus,
    // multipleSales// not found
  };
  deliveryStatusVB.orderDetails.customerInformation.address.addressLine1 = order?.customerInformation?.address?.addressLines[0];
  deliveryStatusVB.orderDetails.customerInformation.address.addressLine2 = order?.customerInformation?.address?.addressLines[1];
  return deliveryStatusVB;
}

export const useFurnitureStore = defineStore('furnitureStore', {
  state: () => ({
    furnitureStatus: {},
    furnitureStatusError: '',
    killSwitch: null,
    updateFurnitureApiError: null,
  }),
  actions: {
    SET_FURNITURE_STATUS(deliveryStatus) {
      this.furnitureStatus = deliveryStatus;
    },
    SET_FURNITURE_STATUS_ERROR(error) {
      this.furnitureStatusError = error;
    },
    SET_KILLSWITCH(killSwitch) {
      this.killSwitch = killSwitch;
    },
    SET_UPDATE_FURNITURE_API_ERROR(payload) {
      this.updateFurnitureApiError = payload;
    },

    async GET_FURNITURE_STATUS({ payloadObj, envProp }) {
      const killSwitch = await $http.get(KILLSWITCHES_ENDPOINT);
      const furnitureLookupEnabled = killSwitch?.data?.killSwitch?.furnitureLookupShopappMigrationEnabled;

      const payload = {};
      if (furnitureLookupEnabled || !envProp?.isMew) {
        if (payloadObj?.requestType === 'TICKET_PHONE_NUMBER') {
          payload.salesCheckNumber = payloadObj?.salesCheckNumber;
          payload.salesPhoneNumber = payloadObj?.salesPhoneNumber;
        }
        if (payloadObj?.requestType === 'NAME_PHONE_NUMBER') {
          payload.firstName = payloadObj?.firstName;
          payload.lastName = payloadObj?.lastName;
          payload.phoneNumber = payloadObj?.phoneNumber;
        }
      }

      if (!furnitureLookupEnabled && envProp?.isMew) {
        payload.deliverystatus = {
          requestType: payloadObj?.requestType,
        };
        if (payloadObj?.requestType === 'TICKET_PHONE_NUMBER') {
          payload.deliverystatus.ticketNumber = payloadObj?.salesCheckNumber;
          payload.deliverystatus.phoneNumber = payloadObj?.salesPhoneNumber;
        }
        if (payloadObj?.requestType === 'NAME_PHONE_NUMBER') {
          payload.deliverystatus.firstName = payloadObj?.firstName;
          payload.deliverystatus.lastName = payloadObj?.lastName;
          payload.deliverystatus.phoneNumber = payloadObj?.phoneNumber;
        }
      }

      await this.SET_FURNITURE_STATUS_ERROR('');
      this.SET_UPDATE_FURNITURE_API_ERROR(null);
      let deliveryStatusVB = {};
      let response = {};

      try {
        if (furnitureLookupEnabled) {
          response = await $http.post(FURNITURE_LOOKUP_ENDPOINT, payload);
        } else {
          const path = envProp?.isMew ? FURNITURE_STATUS_ENDPOINT_MEW_MODE : FURNITURE_STATUS_ENDPOINT;
          response = await $http.post(path, payload, { headers: { 'x-requested-with': 'XMLHttpRequest' } });
        }

        if (furnitureLookupEnabled) {
          if (payloadObj?.multipleOrders && payloadObj?.requestType === 'TICKET_PHONE_NUMBER') {
            deliveryStatusVB = { ...this.furnitureStatus, orderDetails: response.data?.deliveryStatusVB?.orderDetails };
          } else {
            deliveryStatusVB = response.data?.deliveryStatusVB;
          }
        } else if (envProp.isMew && response?.data?.orders?.order.length > 0) {
          deliveryStatusVB = transformMewModeResponseToDesktop(response.data.orders.order[0]);
        } else {
          const errorMessage = response?.data?.deliveryStatusVB?.messages?.errorMessages?.globalMessages[0]?.description;
          if (errorMessage) {
            this.SET_FURNITURE_STATUS_ERROR(errorMessage);
          } else {
            deliveryStatusVB = response.data?.deliveryStatusVB;
          }
        }
        this.SET_FURNITURE_STATUS(deliveryStatusVB);
      } catch (error) {
        let errorMsg = furnitureFallbackError;
        if (furnitureLookupEnabled || !envProp?.isMew) {
          errorMsg = errorHandler(error, furnitureFallbackError);
        } else {
          errorMsg = error.response.data?.errorDetail?.[0] || furnitureFallbackErrorMew;
        }
        this.SET_FURNITURE_STATUS_ERROR(errorMsg);
        this.SET_UPDATE_FURNITURE_API_ERROR(error?.response?.data?.errors?.error?.[0]);
      }
    },
    CLEAR_FURNITURE_STATUS() {
      this.SET_FURNITURE_STATUS({});
      this.SET_FURNITURE_STATUS_ERROR('');
      this.SET_UPDATE_FURNITURE_API_ERROR(null);
    },
    async GET_KILLSWITCH() {
      const response = await $http.get(KILLSWITCHES_ENDPOINT);
      this.SET_KILLSWITCH(response?.data?.killSwitch);
      return response?.data?.killSwitch?.internationalContextDisabled ?? false;
    },
  },
});
